/** The More menu entries and the install hint open the PWA sheets through one window event (PwaLayer listens). */
export const PWA_SHEET_EVENT = 'cadinu:pwa-sheet'
export type PwaSheet = 'install'

export function openPwaSheet(kind: PwaSheet) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<PwaSheet>(PWA_SHEET_EVENT, { detail: kind }))
}
